<div class="h-100 px-0 px-lg-2 px-xl-5 py-2 step-body-scroll">

  <!-- Filter + Search + Dropdown -->
  <div class="d-flex align-items-center flex-wrap gap-2 mb-3">

    <!-- Status Filter Buttons -->
    <div *ngIf="status !== 'pending-payment'" class="gap-3 d-flex mt-4">
      <div *ngFor="let s of statusOptions">
        <button class="btn status-filter-btn" [id]="'id_'+s.value"
          [ngClass]="selectedStatuses.includes(s.value) ? 'active-status' : 'inactive-status'"
          (click)="toggleStatus(s.value)">
          {{ s.label }}
        </button>
      </div>
    </div>

    <!-- Search Box -->
    <div class="search-container mt-4" [style]="status === 'pending-payment' ? 'margin-left: 0;' : ''"
      style="min-width: 25%;">
      <i class="fa fa-search search-icon"></i>
      <input type="text" class="form-control search-input" placeholder="Search a task..."
        (keyup)="applyFilter($event)" />
    </div>

    <!-- role based dropdown filter -->
    <div *ngIf="status != 'pending-payment'" class="dropdown mt-4">
      <button style="color: black; border-color: #E4E4E4; height: 42px; width: 150px;"
        class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
        {{ dataService.role === 'doctor' ? 'Designer' : 'Doctor' }}
        <i class="fa fa-angle-down ms-3"></i>
      </button>
      <ul class="dropdown-menu p-0 step-body-scroll shadow"
        style="height: 410px; width: 275px; inset: 0; right: -50px; border: none;">
        <li class="p-3">{{ dataService.role === 'doctor' ? 'Designer' : 'Doctor' }}</li>
        <li *ngFor="let person of (dataService.role === 'doctor' ? designerList : doctorList)" class="px-3 py-1">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" [id]="person.id"
              [checked]="selectedOptions.includes(person.id)" (change)="toggleOption(person.id)">
            <label class="form-check-label mx-1" [for]="person">{{ person.firstName | titlecase
              }}</label>
            <label style="color: #707070;">({{ person.count }})</label>
          </div>
        </li>
        <li>
          <hr class="dropdown-divider my-3">
        </li>
        <li class="d-flex justify-content-between p-3 pt-0">
          <button style="color: #707070" class="btn btn-link p-0" (click)="clearAll(); $event.stopPropagation();">Clear
            all</button>
          <button style="background-color: #000000; border-color: #000000; border-radius: 7px;"
            class="btn btn-primary btn-sm" (click)="applyAllFilters()">Apply filters</button>
        </li>
      </ul>
    </div>


  </div>

  <!-- Selected Filters Chips -->
  <div class="d-flex flex-wrap gap-2 mb-3" *ngIf="selectedOptions.length > 0">

    <div *ngFor="let id of selectedOptions" class="filter-chip">

      {{ getPersonNameById(id) }}

      <span class="chip-close" (click)="removeSelectedOption(id)">✕</span>
    </div>

  </div>


  <!-- Task Table -->
  <div class="table-container mt-4" >
    <table class="task-table">
      <thead>
        <tr class="text-uppercase small text-muted">
          <th>
            <mat-checkbox *ngIf="status === 'pending-payment'" color="red"
              (change)="toggleAllSelections($event.checked)" [checked]="areAllSelected()"
              [indeterminate]="someSelected() && !areAllSelected()"></mat-checkbox>
            TASK ID
          </th>
          <th>CASE/PATIENT</th>
          <th>CREATE AT</th>
          <th *ngIf="status !== 'pending-payment'">STATUS</th>
          <!-- <th>CREATE BY</th> -->

          <th *ngIf="status !== 'pending-payment' && dataService.role === 'doctor'">DESIGNER</th>
          <th>UNITS</th>
          <th>DESIGN LEVEL</th>
          <th>DELIVERY TIME</th>
          <th>AMOUNT</th>
          <th *ngIf="status !== 'pending-payment'">TIme Left</th>
          <th>ACTION</th>
        </tr>
      </thead>
      <tbody>
          <tr *ngIf="filteredTaskData.length === 0">
    <td colspan="11" class="text-center py-4">
      No Tasks Found.
    </td>
  </tr>
        <tr *ngFor="let task of paginatedData">
          <td>
            <mat-checkbox *ngIf="status === 'pending-payment'" (change)="selectTask(task.taskId, $event.checked)"
              [checked]="selectedTaskIds.includes(task.taskId)"
              [disabled]="!fileCountsTotal[task.taskId] || fileCountsTotal[task.taskId] == 0"></mat-checkbox>
            <!-- {{ task.taskId }} -->
            <a href="javascript:void(0)" *ngIf="dataService.role === 'doctor'"
              (click)="navigateToOrderDetailsPage(task.taskId, currentPage,pageSize)" class="text-decoration-none"
              style="color:#205567;font-weight: 500;">{{task.taskId}}</a>
            <span *ngIf="dataService.role !== 'doctor'" style="color:#205567;font-weight: 500;">{{task.taskId}} </span>
          </td>
          <td>{{ task.refNum }}</td>
          <!-- <td>{{ task.createBy }}</td> -->
          <td>{{ task.createTime | date:'dd/MM/yy, HH:mm' }}</td>
          <td *ngIf="status !== 'pending-payment'">
            <span class="badge text-uppercase px-3 py-1" [ngStyle]="getStatusBadgeStyle(task.status)"
              style="border-radius: 4px; display: flex; align-items: center; justify-content: center; height: 34px;">
              {{ statusMap.get(task.status) }}
            </span>
          </td>

          <td *ngIf="status !== 'pending-payment' && dataService.role === 'doctor'">{{ task.nickName }}</td>
          <td>{{ task.units }}</td>
          <td>{{ task.tier }}</td>
          <td>{{ task.deliveryTime }}</td>
          <td>{{ task.amount.toFixed(2).replace('.', ',') }}€</td>
          <td *ngIf="status !== 'pending-payment'" [ngClass]="{ 
            'text-success': task.timeLeftStr !== '0h 0m', 
            'text-danger': task.timeLeftStr === '0h 0m' 
          }">
            {{ task.timeLeftStr }}
          </td>

          <td style="width: 200px; text-align: center;">
            <div class="d-flex justify-content-center gap-2">
              <!-- Review button -->
              <div class="d-flex flex-column gap-3">
                <!-- Review Order button -->
                <!-- (click)="navigateToOrderDetails(task.taskId)" -->
                <button *ngIf="task.status === 'PF' && dataService.role === 'doctor'" type="button"
                  class="btn btn-sm px-3"
                  style="background-color:#5ECDA7; color:#000; border-color:#5ECDA7;font-size:12px;font-weight: 600;text-wrap: nowrap;"
                  (click)="navigateToOrderDetails(true)" (click)="getFileDetails(task.taskId)">
                  REVIEW ORDER
                </button>
                <button *ngIf="task.status !== 'PP'" type="button" class="btn btn-sm px-3"
                  style="background-color:#5ECDA7; color:#000; border-color:#5ECDA7;font-size:12px;font-weight: 600;text-wrap: nowrap;"
                 (click)="navigateToOrderDetailsURL(task.taskId, currentPage,pageSize)">
                  ORDER DETAILS
                </button>
                <!-- Download Order button -->
                <button *ngIf="(task.status === 'IP' || task.status=='IC') && dataService.role === 'designer'"
                  type="button" class="btn btn-sm px-3"
                  style="background-color:#5ECDA7; color:#000; border-color:#5ECDA7;font-size:12px;font-weight: 600;text-wrap: nowrap;"
                  (click)="openDelievrOrderModal(task.taskId,task.refNum,task.status)">
                  DELIEVER ORDER
                </button>
                <button *ngIf="task.status !== 'PP'" type="button" class="btn btn-sm px-3"
                  style="background-color:#5ECDA7; color:#000; border-color:#5ECDA7;font-size:12px;font-weight: 600;text-wrap: nowrap;"
                  (click)="downloadOrder(task.taskId)">
                  DOWNLOAD ORDER
                </button>



              </div>


            </div>
            <div *ngIf="status === 'pending-payment'" class="d-flex justify-content-center gap-4">
              <span>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                  (click)="edit(task.taskId)" style="cursor: pointer;">
                  <g clip-path="url(#clip0_678_1253)">
                    <path
                      d="M15.5465 1.27501L5.38652 11.435C4.99847 11.821 4.69084 12.2801 4.48142 12.7857C4.27201 13.2914 4.16498 13.8335 4.16652 14.3808V15.5C4.16652 15.721 4.25432 15.933 4.4106 16.0893C4.56688 16.2455 4.77884 16.3333 4.99985 16.3333H6.11902C6.66632 16.3349 7.2085 16.2279 7.71415 16.0184C8.21981 15.809 8.6789 15.5014 9.06485 15.1133L19.2249 4.95334C19.7118 4.46515 19.9853 3.80374 19.9853 3.11418C19.9853 2.42461 19.7118 1.7632 19.2249 1.27501C18.7296 0.801587 18.0708 0.537384 17.3857 0.537384C16.7005 0.537384 16.0418 0.801587 15.5465 1.27501ZM18.0465 3.77501L7.88652 13.935C7.41662 14.402 6.78153 14.6649 6.11902 14.6667H5.83319V14.3808C5.83492 13.7183 6.09783 13.0832 6.56485 12.6133L16.7249 2.45334C16.9028 2.28331 17.1395 2.18842 17.3857 2.18842C17.6318 2.18842 17.8685 2.28331 18.0465 2.45334C18.2215 2.62877 18.3197 2.86642 18.3197 3.11418C18.3197 3.36193 18.2215 3.59958 18.0465 3.77501Z"
                      fill="black" />
                    <path
                      d="M19.1667 7.9825C18.9457 7.9825 18.7337 8.0703 18.5774 8.22658C18.4211 8.38286 18.3333 8.59482 18.3333 8.81583V13H15C14.337 13 13.7011 13.2634 13.2322 13.7322C12.7634 14.2011 12.5 14.837 12.5 15.5V18.8333H4.16667C3.50363 18.8333 2.86774 18.5699 2.3989 18.1011C1.93006 17.6323 1.66667 16.9964 1.66667 16.3333V4.66667C1.66667 4.00363 1.93006 3.36774 2.3989 2.8989C2.86774 2.43006 3.50363 2.16667 4.16667 2.16667H11.7017C11.9227 2.16667 12.1346 2.07887 12.2909 1.92259C12.4472 1.76631 12.535 1.55435 12.535 1.33333C12.535 1.11232 12.4472 0.900358 12.2909 0.744078C12.1346 0.587797 11.9227 0.5 11.7017 0.5H4.16667C3.062 0.501323 2.00297 0.940735 1.22185 1.72185C0.440735 2.50296 0.00132321 3.562 0 4.66667L0 16.3333C0.00132321 17.438 0.440735 18.497 1.22185 19.2782C2.00297 20.0593 3.062 20.4987 4.16667 20.5H13.6192C14.1666 20.5016 14.7089 20.3945 15.2147 20.1851C15.7205 19.9757 16.1797 19.6681 16.5658 19.28L18.7792 17.065C19.1673 16.6791 19.475 16.22 19.6846 15.7143C19.8941 15.2087 20.0013 14.6665 20 14.1192V8.81583C20 8.59482 19.9122 8.38286 19.7559 8.22658C19.5996 8.0703 19.3877 7.9825 19.1667 7.9825ZM15.3875 18.1017C15.0525 18.4358 14.6289 18.6672 14.1667 18.7683V15.5C14.1667 15.279 14.2545 15.067 14.4107 14.9107C14.567 14.7545 14.779 14.6667 15 14.6667H18.2708C18.1677 15.1279 17.9367 15.5508 17.6042 15.8867L15.3875 18.1017Z"
                      fill="black" />
                  </g>
                  <defs>
                    <clipPath id="clip0_678_1253">
                      <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
                    </clipPath>
                  </defs>
                </svg>
              </span>

              <span>
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                  (click)="deleteTask(task.taskId)" style="cursor: pointer;">
                  <g clip-path="url(#clip0_678_1256)">
                    <path
                      d="M17.4998 3.83333H14.9165C14.7231 2.89284 14.2114 2.04779 13.4675 1.4406C12.7237 0.833408 11.7933 0.501212 10.8332 0.5L9.1665 0.5C8.20633 0.501212 7.27594 0.833408 6.53213 1.4406C5.78832 2.04779 5.27658 2.89284 5.08317 3.83333H2.49984C2.27882 3.83333 2.06686 3.92113 1.91058 4.07741C1.7543 4.23369 1.6665 4.44565 1.6665 4.66667C1.6665 4.88768 1.7543 5.09964 1.91058 5.25592C2.06686 5.4122 2.27882 5.5 2.49984 5.5H3.33317V16.3333C3.33449 17.438 3.77391 18.497 4.55502 19.2782C5.33614 20.0593 6.39517 20.4987 7.49984 20.5H12.4998C13.6045 20.4987 14.6635 20.0593 15.4447 19.2782C16.2258 18.497 16.6652 17.438 16.6665 16.3333V5.5H17.4998C17.7208 5.5 17.9328 5.4122 18.0891 5.25592C18.2454 5.09964 18.3332 4.88768 18.3332 4.66667C18.3332 4.44565 18.2454 4.23369 18.0891 4.07741C17.9328 3.92113 17.7208 3.83333 17.4998 3.83333ZM9.1665 2.16667H10.8332C11.3501 2.1673 11.8541 2.32781 12.2762 2.6262C12.6983 2.92459 13.0177 3.34624 13.1907 3.83333H6.809C6.98199 3.34624 7.30142 2.92459 7.72349 2.6262C8.14556 2.32781 8.64961 2.1673 9.1665 2.16667ZM14.9998 16.3333C14.9998 16.9964 14.7364 17.6323 14.2676 18.1011C13.7988 18.5699 13.1629 18.8333 12.4998 18.8333H7.49984C6.8368 18.8333 6.20091 18.5699 5.73207 18.1011C5.26323 17.6323 4.99984 16.9964 4.99984 16.3333V5.5H14.9998V16.3333Z"
                      fill="black" />
                    <path
                      d="M8.33333 15.5C8.55435 15.5 8.76631 15.4122 8.92259 15.2559C9.07887 15.0997 9.16667 14.8877 9.16667 14.6667V9.66668C9.16667 9.44566 9.07887 9.2337 8.92259 9.07742C8.76631 8.92114 8.55435 8.83334 8.33333 8.83334C8.11232 8.83334 7.90036 8.92114 7.74408 9.07742C7.5878 9.2337 7.5 9.44566 7.5 9.66668V14.6667C7.5 14.8877 7.5878 15.0997 7.74408 15.2559C7.90036 15.4122 8.11232 15.5 8.33333 15.5Z"
                      fill="black" />
                    <path
                      d="M11.6668 15.5C11.8878 15.5 12.0998 15.4122 12.2561 15.2559C12.4124 15.0997 12.5002 14.8877 12.5002 14.6667V9.66668C12.5002 9.44566 12.4124 9.2337 12.2561 9.07742C12.0998 8.92114 11.8878 8.83334 11.6668 8.83334C11.4458 8.83334 11.2339 8.92114 11.0776 9.07742C10.9213 9.2337 10.8335 9.44566 10.8335 9.66668V14.6667C10.8335 14.8877 10.9213 15.0997 11.0776 15.2559C11.2339 15.4122 11.4458 15.5 11.6668 15.5Z"
                      fill="black" />
                  </g>
                  <defs>
                    <clipPath id="clip0_678_1256">
                      <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <!-- <i class="fa fa-edit" style="cursor: pointer;" (click)="edit(task.taskId)"></i> -->
              <!-- <i class="fa fa-trash" style="cursor: pointer;" (click)="deleteTask(task.taskId)"></i> -->

            </div>
          </td>
        </tr>
      </tbody>
    </table>


  </div>
  <div class="pagination-container">

  <!-- Left -->
  <div class="page-size">
    Items per page:
    <select [(ngModel)]="pageSize" (change)="onPageSizeChange()">
      <option *ngFor="let size of [5,10,20]"  [value]="size">
        {{ size }}
      </option>
    </select>
  </div>

  <!-- Middle -->
  <div class="page-info">
    {{ currentPage * pageSize + 1 }}
    -
    {{ (currentPage * pageSize) + pageSize > filteredTaskData.length ? filteredTaskData.length : (currentPage * pageSize) + pageSize }}
    of {{ filteredTaskData.length }}
  </div>

  <!-- Right -->
  <div class="pagination-buttons">

    <button (click)="prevPage()" [disabled]="currentPage === 0">
      &lt;
    </button>

    <button
      *ngFor="let page of visiblePages"
      (click)="goToPage(page)"
      [class.active]="page === currentPage">

      {{ page + 1 }}

    </button>

    <span *ngIf="showDots">...</span>

    <button (click)="nextPage()" [disabled]="currentPage === totalPageCount - 1">
      &gt;
    </button>

  </div>


 <!-- Download + Pay Now Row -->
<div *ngIf="status === 'pending-payment'" 
     class="d-flex justify-content-between mt-20 flex-wrap" style="margin-left: 15%;">

  <!-- LEFT -->
  <button class="download-scan-btn" (click)="downloadSelectedTaskFiles()">
    <i class="fa fa-download"></i> Download scan files
  </button>

  <!-- RIGHT -->
  <div class="d-flex align-items-center" style="font-weight: 500; gap:15px;">

    <div *ngIf="paypalOrder.purchase_units">
      Order Total:
      {{paypalOrder.purchase_units[0].amount.value}}€
    </div>

    <button
      style="background:#000; border-radius:6px; height:50px;"
      class="customPreCreateTaskButtons"
      (click)="bypassPayment()">
      Pay Now
    </button>

  </div>
  </div>

  

</div>

</div>
  <div *ngIf="status === 'pending-payment'" class="d-flex justify-content-between align-items-center mt-4 flex-wrap">
    <button class="download-scan-btn" (click)="downloadSelectedTaskFiles()">
      <i class="fa fa-download"></i> Download scan files
    </button>

    <div class="d-flex justify-content-end" *ngIf="status == 'pending-payment'" style="font-weight: 500;">
      <div *ngIf="paypalOrder.purchase_units" class="align-content-center">
        Order Total:
        {{this.paypalOrder.purchase_units[0].amount.value}}€
        <!-- {{this.paypalOrder.purchase_units[0].amount.currency_code}} -->
      </div>
      <div>&nbsp;&nbsp;&nbsp;&nbsp;</div>
      <!-- <div id="paypal-button-container"></div> --> <!-- temporary disable paypal button, bypass payment for now -->
      <!-- <button class="customPreActivatedButtons d-flex align-items-center gap-1 shadow" (click)="completePayment()">Pay Now</button> -->
      <div>
        <button
          style="max-width: 100%; background-image: none; background-color: #000000; border-radius: 6px; height: 50px;"
          class="customPreCreateTaskButtons" (click)="bypassPayment()">
          Pay Now
        </button>
      </div>
    </div>
  </div>

  <!-- inside review modal -->
  <div *ngIf="showFeedbackSaved" class="feedback-message">
    {{ feedbackSavedMessage }}
  </div>


  <div *ngIf="showModelNow" class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-backdrop fade show"></div>
    <div class="modal-dialog modal-dialog-centered" style="z-index: 1200;" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <span *ngIf="stepNumber === 1">Please review your Design and Visalisation files</span>
            <span *ngIf="stepNumber === 2">
              <button (click)="changeStep(1)" (click)="feedbackId = ''" class="btn">
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.3345 6.98965L16.5066 6.98964L16.5066 8.98934L4.33521 8.99006L9.69861 14.3535L8.28439 15.7677L0.506225 7.9895L8.2844 0.211327L9.69861 1.62554L4.3345 6.98965Z"
                    fill="black" />
                </svg>
              </button>
              Rate your order</span>
            <span *ngIf="stepNumber === 3">

              <button (click)="changeStep(1)" (click)="feedbackId = ''" class="btn">
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.3345 6.98965L16.5066 6.98964L16.5066 8.98934L4.33521 8.99006L9.69861 14.3535L8.28439 15.7677L0.506225 7.9895L8.2844 0.211327L9.69861 1.62554L4.3345 6.98965Z"
                    fill="black" />
                </svg>
              </button>
              Request
              correction</span>
            <span *ngIf="stepNumber === 4">
              <button (click)="changeStep(1)" (click)="feedbackId = ''" class="btn">
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.3345 6.98965L16.5066 6.98964L16.5066 8.98934L4.33521 8.99006L9.69861 14.3535L8.28439 15.7677L0.506225 7.9895L8.2844 0.211327L9.69861 1.62554L4.3345 6.98965Z"
                    fill="black" />
                </svg>
              </button>
              Cancel order
            </span>

          </h5>
          <button style="position: absolute; right: 11px" type="button" class="btn-close" aria-label="Close"
            (click)="closeModal(false)" (click)="changeStep(1)" (click)="feedbackId = ''"></button>
        </div>
        <div class="modal-body" style="padding: 24px;">
          <!-- step 3: Request Correction -->
          <div *ngIf="stepNumber === 3" class="d-flex flex-column gap-2">
            <div>
              <span style="color: #707070;font-size: 14px;font-weight: 400;">You have
                {{orderDetailsNew.remainingCorrections}} revisions left.</span>
              <div class="d-flex align-content-start justify-content-start" style="gap:12px; margin-top: 5px;">
                <div style="background: linear-gradient(#FFE9FF,#ADE3D0); padding: 20px 40px; border-radius: 8px;">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1951_7185)">
                      <path
                        d="M1 6V1H3V4.104C5.256 1.542 8.524 0 12 0C18.617 0 24 5.383 24 12H22C22 6.486 17.514 2 12 2C8.846 2 5.885 3.51 4.009 6H8V8H3C1.897 8 1 7.103 1 6ZM21 16H16V18H19.991C18.114 20.49 15.154 22 12 22C6.486 22 2 17.514 2 12H0C0 18.617 5.383 24 12 24C15.476 24 18.744 22.458 21 19.896V23H23V18C23 16.897 22.103 16 21 16Z"
                        fill="#707070" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1951_7185">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                </div>
                <div style="background: linear-gradient(#FFE9FF,#ADE3D0); padding: 20px 40px; border-radius: 8px;">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1951_7185)">
                      <path
                        d="M1 6V1H3V4.104C5.256 1.542 8.524 0 12 0C18.617 0 24 5.383 24 12H22C22 6.486 17.514 2 12 2C8.846 2 5.885 3.51 4.009 6H8V8H3C1.897 8 1 7.103 1 6ZM21 16H16V18H19.991C18.114 20.49 15.154 22 12 22C6.486 22 2 17.514 2 12H0C0 18.617 5.383 24 12 24C15.476 24 18.744 22.458 21 19.896V23H23V18C23 16.897 22.103 16 21 16Z"
                        fill="#707070" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1951_7185">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                </div>
                <div style="background:#FAF9F9;position: relative; padding: 20px 40px; border-radius: 8px;">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1951_7185)">
                      <path
                        d="M1 6V1H3V4.104C5.256 1.542 8.524 0 12 0C18.617 0 24 5.383 24 12H22C22 6.486 17.514 2 12 2C8.846 2 5.885 3.51 4.009 6H8V8H3C1.897 8 1 7.103 1 6ZM21 16H16V18H19.991C18.114 20.49 15.154 22 12 22C6.486 22 2 17.514 2 12H0C0 18.617 5.383 24 12 24C15.476 24 18.744 22.458 21 19.896V23H23V18C23 16.897 22.103 16 21 16Z"
                        fill="#707070" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1951_7185">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                  <svg width="15" height="64" viewBox="0 0 15 64" fill="none" xmlns="http://www.w3.org/2000/svg"
                    style="position: absolute;left:50%;top:0;transform:translateX(-50%)">
                    <path
                      d="M6.99951 -8.75586L2.99951 1.72685L8.49951 8.50977L4.99951 15.2927L9.49951 22.6923L2.99951 33.7916L11.9995 49.2073L6.99951 57.8402L9.49951 64.6231L4.99951 73.2559"
                      stroke="white" stroke-width="5" />
                  </svg>

                </div>

              </div>
            </div>
            <div class="d-flex flex-column gap-2">
              <span style="font-weight: 500;font-size: 16px;">Please provide feedback for the designer:</span>
              <textarea id="" [(ngModel)]="feedbackText" name="feedback"
                style="border: 1px solid #E4E4E4;padding: 16px;border-radius: 8px;outline:none;"></textarea>
            </div>

            <div class="d-flex flex-column gap-2">
              <p class="m-0" style="font-weight: 500;font-size: 16px;">Attach Files:</p>
              <div class="files-wrap d-flex flex-wrap align-items-start gap-2">
                <div class="drag-drop-area w-100" (click)="scanFile.click()">
                  <div class="upload-icon"><!-- your svg … --></div>
                  <p class="drag-drop-text">
                    Drag & Drop or <a href="javascript:void(0)" class="choose-file-link">Choose file</a> to upload
                  </p>
                  <p class="allowed-file-types m-0">PDF, GLB, STEP</p>

                  <input hidden multiple (change)="addFileDetails($event)" #scanFile type="file" id="scanFile"
                    accept=".pdf,.png,.jpg,.jpeg,.stl,.zip" />
                </div>
                <div class="files-stack">
                  <ng-container *ngFor="let p of (progress | keyvalue)">
                    <div class="upload-card">
                      <!-- top row: name + close -->
                      <div class="row-1">
                        <div class="file-name text-truncate" [title]="p.key">{{ p.key }}</div>
                        <button type="button" class="icon-btn" (click)="removeFileByName(p.key); removeProgress(p.key)"
                          aria-label="Remove file">×</button>
                      </div>

                      <!-- second row: size • eta (when uploading) -->
                      <div class="row-2">
                        <span class="muted">{{ p.value.sizeLabel }}</span>
                        <span class="dot" *ngIf="p.value.state === 'uploading' || p.value.state === 'waiting'">•</span>
                        <span class="muted" *ngIf="p.value.state === 'uploading' || p.value.state === 'waiting'">
                          {{ p.value.etaLabel || 'calculating…' }}
                        </span>
                        <span class="muted" *ngIf="p.value.state === 'done'">Completed</span>
                        <span class="muted error" *ngIf="p.value.state === 'error'">Failed</span>

                        <span class="percent" *ngIf="p.value.state !== 'error'">
                          {{ p.value.percent }}%
                        </span>
                      </div>

                      <!-- progress bar -->
                      <div class="bar-wrap" *ngIf="p.value.state !== 'error'">
                        <div class="bar-track">
                          <div class="bar-fill" [style.width.%]="p.value.percent"></div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>

              </div>
            </div>

            <div class="d-flex flex-column" style="gap:12px;margin-top: 80px;">
              <div *ngIf="ShowRequestFeedback"
                style="color: #065c0b; font-weight: 500; font-size: 20px;text-align: center;">
                {{feedbackMessageRequest}}
              </div>

              <button class="w-100 request-btn" [disabled]="isRequestCorrection"
                [ngClass]="{ 'btn-disabled': isRequestCorrection }" (click)="requestCorrection(taskId)">
                Request correction
              </button>
            </div>
          </div>


          <!-- step 1: Main Page -->
          <div *ngIf="stepNumber === 1" class="d-flex flex-column gap-2">

            <!-- step 1: Review your files -->
            <!-- loop here -->

            <ng-container *ngFor="let file of fileDetailsVisual; let isFirst = first">

              <!-- label only once -->
              <h6 *ngIf="isFirst" class="fw-bold mt-3 mb-2"
                [style.color]="file.fileType === 'visual' ? '#6F6F6F ' : '#8B5E3C'">
                {{ file.fileType === 'visual' ? '3D Visualisation Files :' : file.fileType }}
              </h6>

              <!-- file row -->
              <div class="d-flex align-items-center rounded"
                style="gap: 10px; padding: 12px 16px; background-color: #FAF9F9;">

                <div class="d-flex flex-column gap-1 align-items-start">
                  <span class="text-nowrap text-truncate fw-bold" style="max-width: 120px;" title="{{file.fileName}}">
                    {{ file.fileName }}
                  </span>
                  <span>{{ file.fileSize }}</span>
                </div>

                <div class="d-flex align-items-center justify-content-start w-100">
                  <div *ngIf="checkCondition(file.fileId, 1)" class="px-2 py-1"
                    style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #707070;background:#7070701A;">
                    DOWNLOADING
                  </div>
                  <div *ngIf="checkCondition(file.fileId, 2)" class="px-2 py-1"
                    style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #5ECDA7;background:#5ECDA71A;">
                    COMPLETE
                  </div>
                  <div *ngIf="checkCondition(file.fileId, 3)" class="px-2 py-1"
                    style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #ff5b5b;background:#ffe4e4;">
                    ERROR
                  </div>
                </div>

                <div *ngIf="checkCondition(file.fileId, 0)" class="d-flex align-items-center justify-content-center"
                  (click)="downloadFile(file.fileId, file.fileName)">
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1951_2172)">
                      <path
                        d="M9.87823 18.622C10.1568 18.9008 10.4876 19.1219 10.8517 19.2728C11.2158 19.4237 11.6061 19.5014 12.0002 19.5014C12.3944 19.5014 12.7846 19.4237 13.1487 19.2728C13.5128 19.1219 13.8436 18.9008 14.1222 18.622L17.3332 15.411C17.5054 15.2206 17.5977 14.9713 17.5911 14.7147C17.5846 14.458 17.4795 14.2138 17.2978 14.0325C17.1161 13.8512 16.8716 13.7467 16.615 13.7406C16.3584 13.7346 16.1093 13.8274 15.9192 14L12.9932 16.927L13.0002 1.5C13.0002 1.23478 12.8949 0.98043 12.7073 0.792893C12.5198 0.605357 12.2654 0.5 12.0002 0.5C11.735 0.5 11.4807 0.605357 11.2931 0.792893C11.1056 0.98043 11.0002 1.23478 11.0002 1.5L10.9912 16.908L8.08123 14C7.89359 13.8125 7.63914 13.7072 7.37387 13.7073C7.1086 13.7074 6.85423 13.8129 6.66673 14.0005C6.47922 14.1881 6.37393 14.4426 6.37402 14.7079C6.37412 14.9731 6.47959 15.2275 6.66723 15.415L9.87823 18.622Z"
                        fill="black" />
                      <path
                        d="M23 16.5C22.7348 16.5 22.4804 16.6054 22.2929 16.7929C22.1054 16.9804 22 17.2348 22 17.5V21.5C22 21.7652 21.8946 22.0196 21.7071 22.2071C21.5196 22.3946 21.2652 22.5 21 22.5H3C2.73478 22.5 2.48043 22.3946 2.29289 22.2071C2.10536 22.0196 2 21.7652 2 21.5V17.5C2 17.2348 1.89464 16.9804 1.70711 16.7929C1.51957 16.6054 1.26522 16.5 1 16.5C0.734784 16.5 0.48043 16.6054 0.292893 16.7929C0.105357 16.9804 0 17.2348 0 17.5L0 21.5C0 22.2956 0.31607 23.0587 0.87868 23.6213C1.44129 24.1839 2.20435 24.5 3 24.5H21C21.7956 24.5 22.5587 24.1839 23.1213 23.6213C23.6839 23.0587 24 22.2956 24 21.5V17.5C24 17.2348 23.8946 16.9804 23.7071 16.7929C23.5196 16.6054 23.2652 16.5 23 16.5Z"
                        fill="black" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1951_2172">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>

                <div *ngIf="checkCondition(file.fileId, 1)" (click)="downloadFile(file.fileId, file.fileName)"
                  class="d-flex align-items-center justify-content-center">
                  <button
                    style="border: 1.5px solid #E4E4E4;background: none; padding: 5px 15px;border-radius: 8px;">Cancel</button>
                </div>

                <div *ngIf="checkCondition(file.fileId,  2)" class="d-flex align-items-center justify-content-center"
                  (click)="downloadFile(file.fileId, file.fileName)">
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect y="0.5" width="24" height="24" rx="12" fill="black" />
                    <path
                      d="M9.90023 17.2125C9.73305 17.2126 9.56751 17.1797 9.41307 17.1157C9.25863 17.0517 9.11834 16.9579 9.00023 16.8395L6.21973 14.0605L7.28073 13L9.90023 15.6195L16.7197 8.80005L17.7807 9.86055L10.8002 16.8395C10.6821 16.9579 10.5418 17.0517 10.3874 17.1157C10.2329 17.1797 10.0674 17.2126 9.90023 17.2125Z"
                      fill="white" />
                  </svg>
                </div>

                <div *ngIf="checkCondition(file.fileId, 3)" class="d-flex align-items-center justify-content-center"
                  (click)="downloadFile(file.fileId, file.fileName)">
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1951_2172)">
                      <path
                        d="M9.87823 18.622C10.1568 18.9008 10.4876 19.1219 10.8517 19.2728C11.2158 19.4237 11.6061 19.5014 12.0002 19.5014C12.3944 19.5014 12.7846 19.4237 13.1487 19.2728C13.5128 19.1219 13.8436 18.9008 14.1222 18.622L17.3332 15.411C17.5054 15.2206 17.5977 14.9713 17.5911 14.7147C17.5846 14.458 17.4795 14.2138 17.2978 14.0325C17.1161 13.8512 16.8716 13.7467 16.615 13.7406C16.3584 13.7346 16.1093 13.8274 15.9192 14L12.9932 16.927L13.0002 1.5C13.0002 1.23478 12.8949 0.98043 12.7073 0.792893C12.5198 0.605357 12.2654 0.5 12.0002 0.5C11.735 0.5 11.4807 0.605357 11.2931 0.792893C11.1056 0.98043 11.0002 1.23478 11.0002 1.5L10.9912 16.908L8.08123 14C7.89359 13.8125 7.63914 13.7072 7.37387 13.7073C7.1086 13.7074 6.85423 13.8129 6.66673 14.0005C6.47922 14.1881 6.37393 14.4426 6.37402 14.7079C6.37412 14.9731 6.47959 15.2275 6.66723 15.415L9.87823 18.622Z"
                        fill="black" />
                      <path
                        d="M23 16.5C22.7348 16.5 22.4804 16.6054 22.2929 16.7929C22.1054 16.9804 22 17.2348 22 17.5V21.5C22 21.7652 21.8946 22.0196 21.7071 22.2071C21.5196 22.3946 21.2652 22.5 21 22.5H3C2.73478 22.5 2.48043 22.3946 2.29289 22.2071C2.10536 22.0196 2 21.7652 2 21.5V17.5C2 17.2348 1.89464 16.9804 1.70711 16.7929C1.51957 16.6054 1.26522 16.5 1 16.5C0.734784 16.5 0.48043 16.6054 0.292893 16.7929C0.105357 16.9804 0 17.2348 0 17.5L0 21.5C0 22.2956 0.31607 23.0587 0.87868 23.6213C1.44129 24.1839 2.20435 24.5 3 24.5H21C21.7956 24.5 22.5587 24.1839 23.1213 23.6213C23.6839 23.0587 24 22.2956 24 21.5V17.5C24 17.2348 23.8946 16.9804 23.7071 16.7929C23.5196 16.6054 23.2652 16.5 23 16.5Z"
                        fill="black" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1951_2172">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>

              </div>
            </ng-container>

            <ng-container *ngFor="let file of fileDetailsDesign; let isFirst = first">

              <!-- label only once -->
              <h6 *ngIf="isFirst" class="fw-bold mt-3 mb-2"
                [style.color]="file.fileType === 'design' ? '#6F6F6F ' : '#8B5E3C'">
                {{ file.fileType === 'design' ? 'Design Files :' : file.fileType }}
              </h6>

              <!-- file row -->
              <div class="d-flex align-items-center rounded"
                style="gap: 10px; padding: 12px 16px; background-color: #FAF9F9;">

                <div class="d-flex flex-column gap-1 align-items-start">
                  <span class="text-nowrap text-truncate fw-bold" style="max-width: 120px;" title="{{file.fileName}}">
                    {{ file.fileName }}
                  </span>
                  <span>{{ file.fileSize }}</span>
                </div>

                <div class="d-flex align-items-center justify-content-start w-100">
                  <div *ngIf="checkCondition(file.fileId, 1)" class="px-2 py-1"
                    style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #707070;background:#7070701A;">
                    DOWNLOADING
                  </div>
                  <div *ngIf="checkCondition(file.fileId, 2)" class="px-2 py-1"
                    style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #5ECDA7;background:#5ECDA71A;">
                    COMPLETE
                  </div>
                  <div *ngIf="checkCondition(file.fileId, 3)" class="px-2 py-1"
                    style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #ff5b5b;background:#ffe4e4;">
                    ERROR
                  </div>
                </div>


                <div *ngIf="checkCondition(file.fileId, 0)" class="d-flex align-items-center justify-content-center"
                  [style.opacity]="isApproved() ? 1 : 0.4" [style.pointerEvents]="isApproved() ? 'auto' : 'none'"
                  (click)="(isApproved()) && downloadFile(file.fileId, file.fileName)">
                  <ng-container *ngIf="isApproved(); else lockedIcon">
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1951_2172)">
                        <path
                          d="M9.87823 18.622C10.1568 18.9008 10.4876 19.1219 10.8517 19.2728C11.2158 19.4237 11.6061 19.5014 12.0002 19.5014C12.3944 19.5014 12.7846 19.4237 13.1487 19.2728C13.5128 19.1219 13.8436 18.9008 14.1222 18.622L17.3332 15.411C17.5054 15.2206 17.5977 14.9713 17.5911 14.7147C17.5846 14.458 17.4795 14.2138 17.2978 14.0325C17.1161 13.8512 16.8716 13.7467 16.615 13.7406C16.3584 13.7346 16.1093 13.8274 15.9192 14L12.9932 16.927L13.0002 1.5C13.0002 1.23478 12.8949 0.98043 12.7073 0.792893C12.5198 0.605357 12.2654 0.5 12.0002 0.5C11.735 0.5 11.4807 0.605357 11.2931 0.792893C11.1056 0.98043 11.0002 1.23478 11.0002 1.5L10.9912 16.908L8.08123 14C7.89359 13.8125 7.63914 13.7072 7.37387 13.7073C7.1086 13.7074 6.85423 13.8129 6.66673 14.0005C6.47922 14.1881 6.37393 14.4426 6.37402 14.7079C6.37412 14.9731 6.47959 15.2275 6.66723 15.415L9.87823 18.622Z"
                          fill="black" />
                        <path
                          d="M23 16.5C22.7348 16.5 22.4804 16.6054 22.2929 16.7929C22.1054 16.9804 22 17.2348 22 17.5V21.5C22 21.7652 21.8946 22.0196 21.7071 22.2071C21.5196 22.3946 21.2652 22.5 21 22.5H3C2.73478 22.5 2.48043 22.3946 2.29289 22.2071C2.10536 22.0196 2 21.7652 2 21.5V17.5C2 17.2348 1.89464 16.9804 1.70711 16.7929C1.51957 16.6054 1.26522 16.5 1 16.5C0.734784 16.5 0.48043 16.6054 0.292893 16.7929C0.105357 16.9804 0 17.2348 0 17.5L0 21.5C0 22.2956 0.31607 23.0587 0.87868 23.6213C1.44129 24.1839 2.20435 24.5 3 24.5H21C21.7956 24.5 22.5587 24.1839 23.1213 23.6213C23.6839 23.0587 24 22.2956 24 21.5V17.5C24 17.2348 23.8946 16.9804 23.7071 16.7929C23.5196 16.6054 23.2652 16.5 23 16.5Z"
                          fill="black" />
                      </g>
                      <defs>
                        <clipPath id="clip0_1951_2172">
                          <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                        </clipPath>
                      </defs>
                    </svg>

                  </ng-container>
                  <ng-template #lockedIcon>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M6 10V7a6 6 0 1 1 12 0v3" stroke="#4B4B4B" stroke-width="2" stroke-linecap="round" />
                      <rect x="4" y="10" width="16" height="12" rx="2" fill="#B0B0B0" stroke="#4B4B4B"
                        stroke-width="2" />
                      <circle cx="12" cy="16" r="1.5" fill="#4B4B4B" />
                    </svg>
                  </ng-template>
                </div>

                <div *ngIf="checkCondition(file.fileId, 1)" (click)="downloadFile(file.fileId, file.fileName)"
                  class="d-flex align-items-center justify-content-center">
                  <button
                    style="border: 1.5px solid #E4E4E4;background: none; padding: 5px 15px;border-radius: 8px;">Cancel</button>
                </div>

                <div *ngIf="checkCondition(file.fileId,  2)" class="d-flex align-items-center justify-content-center"
                  (click)="downloadFile(file.fileId, file.fileName)">
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect y="0.5" width="24" height="24" rx="12" fill="black" />
                    <path
                      d="M9.90023 17.2125C9.73305 17.2126 9.56751 17.1797 9.41307 17.1157C9.25863 17.0517 9.11834 16.9579 9.00023 16.8395L6.21973 14.0605L7.28073 13L9.90023 15.6195L16.7197 8.80005L17.7807 9.86055L10.8002 16.8395C10.6821 16.9579 10.5418 17.0517 10.3874 17.1157C10.2329 17.1797 10.0674 17.2126 9.90023 17.2125Z"
                      fill="white" />
                  </svg>
                </div>

                <div *ngIf="checkCondition(file.fileId, 3)" class="d-flex align-items-center justify-content-center"
                  (click)="downloadFile(file.fileId, file.fileName)">
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1951_2172)">
                      <path
                        d="M9.87823 18.622C10.1568 18.9008 10.4876 19.1219 10.8517 19.2728C11.2158 19.4237 11.6061 19.5014 12.0002 19.5014C12.3944 19.5014 12.7846 19.4237 13.1487 19.2728C13.5128 19.1219 13.8436 18.9008 14.1222 18.622L17.3332 15.411C17.5054 15.2206 17.5977 14.9713 17.5911 14.7147C17.5846 14.458 17.4795 14.2138 17.2978 14.0325C17.1161 13.8512 16.8716 13.7467 16.615 13.7406C16.3584 13.7346 16.1093 13.8274 15.9192 14L12.9932 16.927L13.0002 1.5C13.0002 1.23478 12.8949 0.98043 12.7073 0.792893C12.5198 0.605357 12.2654 0.5 12.0002 0.5C11.735 0.5 11.4807 0.605357 11.2931 0.792893C11.1056 0.98043 11.0002 1.23478 11.0002 1.5L10.9912 16.908L8.08123 14C7.89359 13.8125 7.63914 13.7072 7.37387 13.7073C7.1086 13.7074 6.85423 13.8129 6.66673 14.0005C6.47922 14.1881 6.37393 14.4426 6.37402 14.7079C6.37412 14.9731 6.47959 15.2275 6.66723 15.415L9.87823 18.622Z"
                        fill="black" />
                      <path
                        d="M23 16.5C22.7348 16.5 22.4804 16.6054 22.2929 16.7929C22.1054 16.9804 22 17.2348 22 17.5V21.5C22 21.7652 21.8946 22.0196 21.7071 22.2071C21.5196 22.3946 21.2652 22.5 21 22.5H3C2.73478 22.5 2.48043 22.3946 2.29289 22.2071C2.10536 22.0196 2 21.7652 2 21.5V17.5C2 17.2348 1.89464 16.9804 1.70711 16.7929C1.51957 16.6054 1.26522 16.5 1 16.5C0.734784 16.5 0.48043 16.6054 0.292893 16.7929C0.105357 16.9804 0 17.2348 0 17.5L0 21.5C0 22.2956 0.31607 23.0587 0.87868 23.6213C1.44129 24.1839 2.20435 24.5 3 24.5H21C21.7956 24.5 22.5587 24.1839 23.1213 23.6213C23.6839 23.0587 24 22.2956 24 21.5V17.5C24 17.2348 23.8946 16.9804 23.7071 16.7929C23.5196 16.6054 23.2652 16.5 23 16.5Z"
                        fill="black" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1951_2172">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>

              </div>
            </ng-container>


            <!-- Design Files Loop -->
            <ng-container *ngFor="let file of fileDetailsCorrected3dVisualisation; let isFirst = first">

              <!-- label only once -->
              <h6 *ngIf="isFirst" class="fw-bold mt-3 mb-2"
                [style.color]="file.fileType === 'correctedvisual' ? '#6F6F6F ' : '#8B5E3C'">
                {{ file.fileType === 'correctedvisual' ? 'Corrected 3D Visualisation Files :' : file.fileType }}
              </h6>

              <!-- file row -->
              <div class="d-flex align-items-center rounded"
                style="gap: 10px; padding: 12px 16px; background-color: #FAF9F9;">

                <div class="d-flex flex-column gap-1 align-items-start">
                  <span class="text-nowrap text-truncate fw-bold" style="max-width: 120px;" title="{{file.fileName}}">
                    {{ file.fileName }}
                  </span>
                  <span>{{ file.fileSize }}</span>
                </div>

                <div class="d-flex align-items-center justify-content-start w-100">
                  <div *ngIf="checkCondition(file.fileId, 1)" class="px-2 py-1"
                    style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #707070;background:#7070701A;">
                    DOWNLOADING
                  </div>
                  <div *ngIf="checkCondition(file.fileId, 2)" class="px-2 py-1"
                    style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #5ECDA7;background:#5ECDA71A;">
                    COMPLETE
                  </div>
                  <div *ngIf="checkCondition(file.fileId, 3)" class="px-2 py-1"
                    style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #ff5b5b;background:#ffe4e4;">
                    ERROR
                  </div>
                </div>
                <div *ngIf="checkCondition(file.fileId,  0)" class="d-flex align-items-center justify-content-center"
                  (click)="downloadFile(file.fileId, file.fileName)">
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1951_2172)">
                      <path
                        d="M9.87823 18.622C10.1568 18.9008 10.4876 19.1219 10.8517 19.2728C11.2158 19.4237 11.6061 19.5014 12.0002 19.5014C12.3944 19.5014 12.7846 19.4237 13.1487 19.2728C13.5128 19.1219 13.8436 18.9008 14.1222 18.622L17.3332 15.411C17.5054 15.2206 17.5977 14.9713 17.5911 14.7147C17.5846 14.458 17.4795 14.2138 17.2978 14.0325C17.1161 13.8512 16.8716 13.7467 16.615 13.7406C16.3584 13.7346 16.1093 13.8274 15.9192 14L12.9932 16.927L13.0002 1.5C13.0002 1.23478 12.8949 0.98043 12.7073 0.792893C12.5198 0.605357 12.2654 0.5 12.0002 0.5C11.735 0.5 11.4807 0.605357 11.2931 0.792893C11.1056 0.98043 11.0002 1.23478 11.0002 1.5L10.9912 16.908L8.08123 14C7.89359 13.8125 7.63914 13.7072 7.37387 13.7073C7.1086 13.7074 6.85423 13.8129 6.66673 14.0005C6.47922 14.1881 6.37393 14.4426 6.37402 14.7079C6.37412 14.9731 6.47959 15.2275 6.66723 15.415L9.87823 18.622Z"
                        fill="black" />
                      <path
                        d="M23 16.5C22.7348 16.5 22.4804 16.6054 22.2929 16.7929C22.1054 16.9804 22 17.2348 22 17.5V21.5C22 21.7652 21.8946 22.0196 21.7071 22.2071C21.5196 22.3946 21.2652 22.5 21 22.5H3C2.73478 22.5 2.48043 22.3946 2.29289 22.2071C2.10536 22.0196 2 21.7652 2 21.5V17.5C2 17.2348 1.89464 16.9804 1.70711 16.7929C1.51957 16.6054 1.26522 16.5 1 16.5C0.734784 16.5 0.48043 16.6054 0.292893 16.7929C0.105357 16.9804 0 17.2348 0 17.5L0 21.5C0 22.2956 0.31607 23.0587 0.87868 23.6213C1.44129 24.1839 2.20435 24.5 3 24.5H21C21.7956 24.5 22.5587 24.1839 23.1213 23.6213C23.6839 23.0587 24 22.2956 24 21.5V17.5C24 17.2348 23.8946 16.9804 23.7071 16.7929C23.5196 16.6054 23.2652 16.5 23 16.5Z"
                        fill="black" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1951_2172">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>

                <div *ngIf="checkCondition(file.fileId, 1)" (click)="downloadFile(file.fileId, file.fileName)"
                  class="d-flex align-items-center justify-content-center">
                  <button
                    style="border: 1.5px solid #E4E4E4;background: none; padding: 5px 15px;border-radius: 8px;">Cancel</button>
                </div>

                <div *ngIf="checkCondition(file.fileId, 2)" class="d-flex align-items-center justify-content-center"
                  (click)="downloadFile(file.fileId, file.fileName)">
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect y="0.5" width="24" height="24" rx="12" fill="black" />
                    <path
                      d="M9.90023 17.2125C9.73305 17.2126 9.56751 17.1797 9.41307 17.1157C9.25863 17.0517 9.11834 16.9579 9.00023 16.8395L6.21973 14.0605L7.28073 13L9.90023 15.6195L16.7197 8.80005L17.7807 9.86055L10.8002 16.8395C10.6821 16.9579 10.5418 17.0517 10.3874 17.1157C10.2329 17.1797 10.0674 17.2126 9.90023 17.2125Z"
                      fill="white" />
                  </svg>
                </div>

                <div *ngIf="checkCondition(file.fileId, 3)" class="d-flex align-items-center justify-content-center"
                  (click)="downloadFile(file.fileId, file.fileName)">
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1951_2172)">
                      <path
                        d="M9.87823 18.622C10.1568 18.9008 10.4876 19.1219 10.8517 19.2728C11.2158 19.4237 11.6061 19.5014 12.0002 19.5014C12.3944 19.5014 12.7846 19.4237 13.1487 19.2728C13.5128 19.1219 13.8436 18.9008 14.1222 18.622L17.3332 15.411C17.5054 15.2206 17.5977 14.9713 17.5911 14.7147C17.5846 14.458 17.4795 14.2138 17.2978 14.0325C17.1161 13.8512 16.8716 13.7467 16.615 13.7406C16.3584 13.7346 16.1093 13.8274 15.9192 14L12.9932 16.927L13.0002 1.5C13.0002 1.23478 12.8949 0.98043 12.7073 0.792893C12.5198 0.605357 12.2654 0.5 12.0002 0.5C11.735 0.5 11.4807 0.605357 11.2931 0.792893C11.1056 0.98043 11.0002 1.23478 11.0002 1.5L10.9912 16.908L8.08123 14C7.89359 13.8125 7.63914 13.7072 7.37387 13.7073C7.1086 13.7074 6.85423 13.8129 6.66673 14.0005C6.47922 14.1881 6.37393 14.4426 6.37402 14.7079C6.37412 14.9731 6.47959 15.2275 6.66723 15.415L9.87823 18.622Z"
                        fill="black" />
                      <path
                        d="M23 16.5C22.7348 16.5 22.4804 16.6054 22.2929 16.7929C22.1054 16.9804 22 17.2348 22 17.5V21.5C22 21.7652 21.8946 22.0196 21.7071 22.2071C21.5196 22.3946 21.2652 22.5 21 22.5H3C2.73478 22.5 2.48043 22.3946 2.29289 22.2071C2.10536 22.0196 2 21.7652 2 21.5V17.5C2 17.2348 1.89464 16.9804 1.70711 16.7929C1.51957 16.6054 1.26522 16.5 1 16.5C0.734784 16.5 0.48043 16.6054 0.292893 16.7929C0.105357 16.9804 0 17.2348 0 17.5L0 21.5C0 22.2956 0.31607 23.0587 0.87868 23.6213C1.44129 24.1839 2.20435 24.5 3 24.5H21C21.7956 24.5 22.5587 24.1839 23.1213 23.6213C23.6839 23.0587 24 22.2956 24 21.5V17.5C24 17.2348 23.8946 16.9804 23.7071 16.7929C23.5196 16.6054 23.2652 16.5 23 16.5Z"
                        fill="black" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1951_2172">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
            </ng-container>
            <!-- Design Files Loop -->
            <ng-container *ngFor="let file of fileDetailsCorrectedDesign; let isFirst = first">

              <!-- label only once -->
              <h6 *ngIf="isFirst" class="fw-bold mt-3 mb-2"
                [style.color]="file.fileType === 'correcteddesign' ? '#6F6F6F ' : '#8B5E3C'">
                {{ file.fileType === 'correcteddesign' ? 'Corrected Design Files :' : file.fileType }}
              </h6>

              <!-- file row -->
              <div class="d-flex align-items-center rounded"
                style="gap: 10px; padding: 12px 16px; background-color: #FAF9F9;">

                <div class="d-flex flex-column gap-1 align-items-start">
                  <span class="text-nowrap text-truncate fw-bold" style="max-width: 120px;" title="{{file.fileName}}">
                    {{ file.fileName }}
                  </span>
                  <span>{{ file.fileSize }}</span>
                </div>

                <div class="d-flex align-items-center justify-content-start w-100">
                  <div *ngIf="checkCondition(file.fileId, 1)" class="px-2 py-1"
                    style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #707070;background:#7070701A;">
                    DOWNLOADING
                  </div>
                  <div *ngIf="checkCondition(file.fileId, 2)" class="px-2 py-1"
                    style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #5ECDA7;background:#5ECDA71A;">
                    COMPLETE
                  </div>
                  <div *ngIf="checkCondition(file.fileId, 3)" class="px-2 py-1"
                    style="font-weight: 500; border-radius: 3px; font-size: 14px; color: #ff5b5b;background:#ffe4e4;">
                    ERROR
                  </div>
                </div>
                <div *ngIf="checkCondition(file.fileId, 0)" class="d-flex align-items-center justify-content-center"
                  [style.opacity]="(isApproved() || !hasCorrected3d()) ? 1 : 0.4"
                  [style.pointerEvents]="(isApproved() || !hasCorrected3d()) ? 'auto' : 'none'"
                  (click)="(isApproved() || !hasCorrected3d()) && downloadFile(file.fileId, file.fileName)">
                  <ng-container *ngIf="(isApproved() || !hasCorrected3d()); else lockedIcon">
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1951_2172)">
                        <path
                          d="M9.87823 18.622C10.1568 18.9008 10.4876 19.1219 10.8517 19.2728C11.2158 19.4237 11.6061 19.5014 12.0002 19.5014C12.3944 19.5014 12.7846 19.4237 13.1487 19.2728C13.5128 19.1219 13.8436 18.9008 14.1222 18.622L17.3332 15.411C17.5054 15.2206 17.5977 14.9713 17.5911 14.7147C17.5846 14.458 17.4795 14.2138 17.2978 14.0325C17.1161 13.8512 16.8716 13.7467 16.615 13.7406C16.3584 13.7346 16.1093 13.8274 15.9192 14L12.9932 16.927L13.0002 1.5C13.0002 1.23478 12.8949 0.98043 12.7073 0.792893C12.5198 0.605357 12.2654 0.5 12.0002 0.5C11.735 0.5 11.4807 0.605357 11.2931 0.792893C11.1056 0.98043 11.0002 1.23478 11.0002 1.5L10.9912 16.908L8.08123 14C7.89359 13.8125 7.63914 13.7072 7.37387 13.7073C7.1086 13.7074 6.85423 13.8129 6.66673 14.0005C6.47922 14.1881 6.37393 14.4426 6.37402 14.7079C6.37412 14.9731 6.47959 15.2275 6.66723 15.415L9.87823 18.622Z"
                          fill="black" />
                        <path
                          d="M23 16.5C22.7348 16.5 22.4804 16.6054 22.2929 16.7929C22.1054 16.9804 22 17.2348 22 17.5V21.5C22 21.7652 21.8946 22.0196 21.7071 22.2071C21.5196 22.3946 21.2652 22.5 21 22.5H3C2.73478 22.5 2.48043 22.3946 2.29289 22.2071C2.10536 22.0196 2 21.7652 2 21.5V17.5C2 17.2348 1.89464 16.9804 1.70711 16.7929C1.51957 16.6054 1.26522 16.5 1 16.5C0.734784 16.5 0.48043 16.6054 0.292893 16.7929C0.105357 16.9804 0 17.2348 0 17.5L0 21.5C0 22.2956 0.31607 23.0587 0.87868 23.6213C1.44129 24.1839 2.20435 24.5 3 24.5H21C21.7956 24.5 22.5587 24.1839 23.1213 23.6213C23.6839 23.0587 24 22.2956 24 21.5V17.5C24 17.2348 23.8946 16.9804 23.7071 16.7929C23.5196 16.6054 23.2652 16.5 23 16.5Z"
                          fill="black" />
                      </g>
                      <defs>
                        <clipPath id="clip0_1951_2172">
                          <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                        </clipPath>
                      </defs>
                    </svg>

                  </ng-container>
                  <ng-template #lockedIcon>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M6 10V7a6 6 0 1 1 12 0v3" stroke="#4B4B4B" stroke-width="2" stroke-linecap="round" />
                      <rect x="4" y="10" width="16" height="12" rx="2" fill="#B0B0B0" stroke="#4B4B4B"
                        stroke-width="2" />
                      <circle cx="12" cy="16" r="1.5" fill="#4B4B4B" />
                    </svg>
                  </ng-template>
                </div>

                <div *ngIf="checkCondition(file.fileId, 1)" (click)="downloadFile(file.fileId, file.fileName)"
                  class="d-flex align-items-center justify-content-center">
                  <button
                    style="border: 1.5px solid #E4E4E4;background: none; padding: 5px 15px;border-radius: 8px;">Cancel</button>
                </div>

                <div *ngIf="checkCondition(file.fileId, 2)" class="d-flex align-items-center justify-content-center"
                  (click)="downloadFile(file.fileId, file.fileName)">
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect y="0.5" width="24" height="24" rx="12" fill="black" />
                    <path
                      d="M9.90023 17.2125C9.73305 17.2126 9.56751 17.1797 9.41307 17.1157C9.25863 17.0517 9.11834 16.9579 9.00023 16.8395L6.21973 14.0605L7.28073 13L9.90023 15.6195L16.7197 8.80005L17.7807 9.86055L10.8002 16.8395C10.6821 16.9579 10.5418 17.0517 10.3874 17.1157C10.2329 17.1797 10.0674 17.2126 9.90023 17.2125Z"
                      fill="white" />
                  </svg>
                </div>

                <div *ngIf="checkCondition(file.fileId, 3)" class="d-flex align-items-center justify-content-center"
                  (click)="downloadFile(file.fileId, file.fileName)">
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1951_2172)">
                      <path
                        d="M9.87823 18.622C10.1568 18.9008 10.4876 19.1219 10.8517 19.2728C11.2158 19.4237 11.6061 19.5014 12.0002 19.5014C12.3944 19.5014 12.7846 19.4237 13.1487 19.2728C13.5128 19.1219 13.8436 18.9008 14.1222 18.622L17.3332 15.411C17.5054 15.2206 17.5977 14.9713 17.5911 14.7147C17.5846 14.458 17.4795 14.2138 17.2978 14.0325C17.1161 13.8512 16.8716 13.7467 16.615 13.7406C16.3584 13.7346 16.1093 13.8274 15.9192 14L12.9932 16.927L13.0002 1.5C13.0002 1.23478 12.8949 0.98043 12.7073 0.792893C12.5198 0.605357 12.2654 0.5 12.0002 0.5C11.735 0.5 11.4807 0.605357 11.2931 0.792893C11.1056 0.98043 11.0002 1.23478 11.0002 1.5L10.9912 16.908L8.08123 14C7.89359 13.8125 7.63914 13.7072 7.37387 13.7073C7.1086 13.7074 6.85423 13.8129 6.66673 14.0005C6.47922 14.1881 6.37393 14.4426 6.37402 14.7079C6.37412 14.9731 6.47959 15.2275 6.66723 15.415L9.87823 18.622Z"
                        fill="black" />
                      <path
                        d="M23 16.5C22.7348 16.5 22.4804 16.6054 22.2929 16.7929C22.1054 16.9804 22 17.2348 22 17.5V21.5C22 21.7652 21.8946 22.0196 21.7071 22.2071C21.5196 22.3946 21.2652 22.5 21 22.5H3C2.73478 22.5 2.48043 22.3946 2.29289 22.2071C2.10536 22.0196 2 21.7652 2 21.5V17.5C2 17.2348 1.89464 16.9804 1.70711 16.7929C1.51957 16.6054 1.26522 16.5 1 16.5C0.734784 16.5 0.48043 16.6054 0.292893 16.7929C0.105357 16.9804 0 17.2348 0 17.5L0 21.5C0 22.2956 0.31607 23.0587 0.87868 23.6213C1.44129 24.1839 2.20435 24.5 3 24.5H21C21.7956 24.5 22.5587 24.1839 23.1213 23.6213C23.6839 23.0587 24 22.2956 24 21.5V17.5C24 17.2348 23.8946 16.9804 23.7071 16.7929C23.5196 16.6054 23.2652 16.5 23 16.5Z"
                        fill="black" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1951_2172">
                        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
            </ng-container>
            <!-- loop end -->

            <div class="w-100 d-flex justify-content-center" style="margin-top: 80px;">
              <p style="font-weight: 400;font-size: 14px;color: #707070;text-align: center;width: 332px;">The order did
                not go according to your wishes and the results are not satisfactory? <a style="cursor: pointer;"
                  (click)="changeStep(4)" (click)="feedbackId = '1'">Cancel Order</a></p>
            </div>
            <div class="d-flex gap-2 justify-content-center">
              <div *ngIf="!isApproved()" class="d-flex gap-2 justify-content-center">
                <div *ngIf="!isApproved()" class="d-flex gap-2 justify-content-center">
                  <button (click)="changeStep(3); feedbackId = '2'" [disabled]="isRequestCorrection"
                    [class.disabled-btn]="isRequestCorrection"
                    style=" border-radius: 8px; border:1.5px solid #E4E4E4; font-size: 13px;font-weight: 500;padding: 14px 35px;min-width: 180px;">
                    Request correction
                  </button>

                  <button (click)="onApprove()" [disabled]="isRequestCorrection"
                    [class.disabled-btn]="isRequestCorrection" style=" background: #5ECDA7;border-radius: 8px; border:1.5px solid #E4E4E4;
                    font-size: 13px;font-weight: 500;padding: 14px 35px;min-width: 180px;">
                    Approve
                  </button>
                </div>
              </div>


              <div *ngIf="!showButtons && showFeedbackMessage"
                style="color: #065c0b; font-weight: 500; font-size: 20px;">
                {{ feedbackMessage }}
              </div>


            </div>

            <!-- step 2: Provide feedback -->
            <div *ngIf="stepNumber === 2" class="d-flex flex-column gap-2">
              <div>
                <span style="color: #707070;font-size: 14px;font-weight: 400;">Help us to improve our platform with your
                  review.</span>
              </div>
              <div class="star-rating">
                <span *ngFor="let star of stars; let i = index" (click)="rate(i + 1)" (mouseenter)="hover(i + 1)"
                  (mouseleave)="hover(0)" class="star" [class.filled]="(hoveredRating || rating) > i">
                  ★
                </span>
              </div>
              <div class="d-flex flex-column" style="gap:12px;margin-top: 80px;">
                <button class="w-100"
                  style="text-decoration: underline;font-weight: 400;font-size: 14px;background: none;border:none;outline:none;">Skip</button>
                <button class="w-100" (click)="cancelOrder()"
                  style="background: #5ECDA7;padding: 12px 16px;border-radius: 8px;border: none;font-size: 14px;outline: none;font-weight: 500;">Send</button>
              </div>
            </div>


            <!-- step 3: Request Correction -->
            <div *ngIf="stepNumber === 3" class="d-flex flex-column gap-2">
              <div>
                <span style="color: #707070;font-size: 14px;font-weight: 400;">You have
                  {{orderDetailsNew.remainingCorrections}} revisions left.</span>
                <div class="d-flex align-content-start justify-content-start" style="gap:12px; margin-top: 5px;">
                  <div style="background: linear-gradient(#FFE9FF,#ADE3D0); padding: 20px 40px; border-radius: 8px;">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1951_7185)">
                        <path
                          d="M1 6V1H3V4.104C5.256 1.542 8.524 0 12 0C18.617 0 24 5.383 24 12H22C22 6.486 17.514 2 12 2C8.846 2 5.885 3.51 4.009 6H8V8H3C1.897 8 1 7.103 1 6ZM21 16H16V18H19.991C18.114 20.49 15.154 22 12 22C6.486 22 2 17.514 2 12H0C0 18.617 5.383 24 12 24C15.476 24 18.744 22.458 21 19.896V23H23V18C23 16.897 22.103 16 21 16Z"
                          fill="#707070" />
                      </g>
                      <defs>
                        <clipPath id="clip0_1951_7185">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>

                  </div>
                  <div style="background: linear-gradient(#FFE9FF,#ADE3D0); padding: 20px 40px; border-radius: 8px;">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1951_7185)">
                        <path
                          d="M1 6V1H3V4.104C5.256 1.542 8.524 0 12 0C18.617 0 24 5.383 24 12H22C22 6.486 17.514 2 12 2C8.846 2 5.885 3.51 4.009 6H8V8H3C1.897 8 1 7.103 1 6ZM21 16H16V18H19.991C18.114 20.49 15.154 22 12 22C6.486 22 2 17.514 2 12H0C0 18.617 5.383 24 12 24C15.476 24 18.744 22.458 21 19.896V23H23V18C23 16.897 22.103 16 21 16Z"
                          fill="#707070" />
                      </g>
                      <defs>
                        <clipPath id="clip0_1951_7185">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>

                  </div>
                  <div style="background:#FAF9F9;position: relative; padding: 20px 40px; border-radius: 8px;">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1951_7185)">
                        <path
                          d="M1 6V1H3V4.104C5.256 1.542 8.524 0 12 0C18.617 0 24 5.383 24 12H22C22 6.486 17.514 2 12 2C8.846 2 5.885 3.51 4.009 6H8V8H3C1.897 8 1 7.103 1 6ZM21 16H16V18H19.991C18.114 20.49 15.154 22 12 22C6.486 22 2 17.514 2 12H0C0 18.617 5.383 24 12 24C15.476 24 18.744 22.458 21 19.896V23H23V18C23 16.897 22.103 16 21 16Z"
                          fill="#707070" />
                      </g>
                      <defs>
                        <clipPath id="clip0_1951_7185">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>

                    <svg width="15" height="64" viewBox="0 0 15 64" fill="none" xmlns="http://www.w3.org/2000/svg"
                      style="position: absolute;left:50%;top:0;transform:translateX(-50%)">
                      <path
                        d="M6.99951 -8.75586L2.99951 1.72685L8.49951 8.50977L4.99951 15.2927L9.49951 22.6923L2.99951 33.7916L11.9995 49.2073L6.99951 57.8402L9.49951 64.6231L4.99951 73.2559"
                        stroke="white" stroke-width="5" />
                    </svg>

                  </div>

                </div>
              </div>
              <div class="d-flex flex-column gap-2">
                <span style="font-weight: 500;font-size: 16px;">Please provide feedback for the designer:</span>
                <textarea id="" [(ngModel)]="feedbackText" name="feedback"
                  style="border: 1px solid #E4E4E4;padding: 16px;border-radius: 8px;outline:none;"></textarea>
              </div>

              <div class="d-flex flex-column gap-2">
                <p class="m-0" style="font-weight: 500;font-size: 16px;">Attach Files:</p>
                <div class="files-wrap d-flex flex-wrap align-items-start gap-2">
                  <div class="drag-drop-area w-100" (click)="scanFile.click()">
                    <div class="upload-icon"><!-- your svg … --></div>
                    <p class="drag-drop-text">
                      Drag & Drop or <a href="javascript:void(0)" class="choose-file-link">Choose file</a> to upload
                    </p>
                    <p class="allowed-file-types m-0">PDF, GLB, STEP</p>

                    <input hidden multiple (change)="addFileDetails($event)" #scanFile type="file" id="scanFile"
                      accept=".pdf,.png,.jpg,.jpeg,.stl,.zip" />
                  </div>
                  <div class="files-stack">
                    <ng-container *ngFor="let p of (progress | keyvalue)">
                      <div class="upload-card">
                        <!-- top row: name + close -->
                        <div class="row-1">
                          <div class="file-name text-truncate" [title]="p.key">{{ p.key }}</div>
                          <button type="button" class="icon-btn"
                            (click)="removeFileByName(p.key); removeProgress(p.key)" aria-label="Remove file">×</button>
                        </div>

                        <!-- second row: size • eta (when uploading) -->
                        <div class="row-2">
                          <span class="muted">{{ p.value.sizeLabel }}</span>
                          <span class="dot"
                            *ngIf="p.value.state === 'uploading' || p.value.state === 'waiting'">•</span>
                          <span class="muted" *ngIf="p.value.state === 'uploading' || p.value.state === 'waiting'">
                            {{ p.value.etaLabel || 'calculating…' }}
                          </span>
                          <span class="muted" *ngIf="p.value.state === 'done'">Completed</span>
                          <span class="muted error" *ngIf="p.value.state === 'error'">Failed</span>

                          <span class="percent" *ngIf="p.value.state !== 'error'">
                            {{ p.value.percent }}%
                          </span>
                        </div>

                        <!-- progress bar -->
                        <div class="bar-wrap" *ngIf="p.value.state !== 'error'">
                          <div class="bar-track">
                            <div class="bar-fill" [style.width.%]="p.value.percent"></div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>

                </div>
              </div>

              <div class="d-flex flex-column" style="gap:12px;margin-top: 80px;">
                <button class="w-100"
                  style="background: #5ECDA7;padding: 12px 16px;border-radius: 8px;border: none;font-size: 14px;outline: none;font-weight: 500;"
                  (click)="requestCorrection(taskId)">Request
                  correction</button>
              </div>
            </div>


            <!-- step 4: Cancel Order -->
            <div *ngIf="stepNumber === 4" class="d-flex flex-column gap-2">

              <div class="d-flex flex-column gap-2">
                <span style="font-weight: 500;font-size: 16px;">Please tell us in as much detail as
                  possible why you would like to cancel this order:</span>
                <textarea name="" id="" [(ngModel)]="cancelReason"
                  style="border: 1px solid #E4E4E4;padding: 16px;border-radius: 8px;outline:none;"></textarea>
              </div>

              <div class="d-flex flex-column" style="gap:12px;margin-top: 80px;">
                <button class="w-100"
                  style="text-decoration: underline;font-weight: 400;font-size: 14px;background: none;border:none;outline:none;">Skip</button>
                <button class="w-100" (click)="submitFeedback(taskId); showReviewOverlay = false"
                  style="background: #5ECDA7;padding: 12px 16px;border-radius: 8px;border: none;font-size: 14px;outline: none;font-weight: 500;">Send</button>
              </div>


            </div>


          </div>
        </div>
      </div>


    </div>